<template>
	<div class="px-5">
		<h1 class="section-title-responsive mb-6 md:mb-10 text-white text-center">{{locales && locales.pages && locales.pages.subscribe_to_let_your_property}}</h1>

		<div class="rent-property-sh-form">
		
			<div class="flex flex-col gap-6 mb-6 md:mb-10">
				<h2 class="section-title-xs">{{ subscriptionsYourDetails }}</h2>

				<theme-input 
					:label="usersCompanyName" 
					name="company[company_name]" 
					v-validate="`alpha_num_spaces`"
					:placeholder="usersCompanyNamePlaceholder"
				></theme-input>

				<theme-radios 
					name="title_id"
					:options="usersSex"
					:rules="`required|make_choice`"
				></theme-radios>

				<theme-input 
					:label="usersFirstName" 
					name="first_name" 
					v-validate="`required|alpha_spaces_dash`"
					:isRequired="true"
					:placeholder="usersFirstNamePlaceholder"
				></theme-input>

				<theme-input 
					:label="usersMiddleName" 
					name="middle_name"
					:placeholder="usersMiddleNamePlaceholder"
				></theme-input>

				<theme-input 
					:label="usersLastName" 
					name="last_name" 
					v-validate="`required|alpha_spaces_dash`"
					:isRequired="true"
					:placeholder="usersLastNamePlaceholder"
				></theme-input>

				<div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
					<theme-input 
						:label="usersPhoneNumber" 
						name="phone_number" 
						v-validate="`required|phone_number`"
						:isRequired="true"
						:placeholder="usersPhoneNumberPlaceholder"
					></theme-input>

					<div>
						<theme-input 
							:label="usersEmail" 
							name="email" 
							v-validate="`required|email`" 
							@blur="checkMail"
							:isRequired="true"
							:placeholder="usersEmailPlaceholder"
						></theme-input>

						<div class="form__item" v-if="!!is_user_already_exists">
								<label class="form__label"></label>
								<b style="color: red">{{ userAlreadyExists }}</b>
								<input type="hidden" name="user_already_exists" v-validate="`required`" />
						</div>
					</div>
				</div>

				<div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
					<theme-input
						:label="usersPassword"
						name="password"
						type="password"
						ref="password"
						:placeholder="usersPasswordPlaceholder"
						v-validate="`required`"
						:isRequired="true"
						></theme-input>
						
						
					<theme-input
						:label="usersPasswordRepeat"
						type="password"
						name="confirm_password"
						:placeholder="usersPasswordRepeatPlaceholder"
						v-validate="`required|confirmed:password`"
						:isRequired="true"
						></theme-input> 

				</div>
			</div>

			<div class="flex flex-col gap-6 mb-6 md:mb-10">
				<h2 class="section-title-xs">{{ propDetails }}</h2>

				<div class="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-8">

					<theme-input 
						:label="propPostCode" 
						name="postcode" 
						v-validate="`required|post_code`"
						:isRequired="true"
						:placeholder="propPostCodePlaceholder"
					></theme-input>

					<theme-input 
						:label="propBuildingUid" 
						name="building_uid" 
						v-validate="`required`"
						:isRequired="true"
						:placeholder="propBuildingUidPlaceholder"
					></theme-input>

					<theme-input 
						:label="propBuildingUidApp" 
						name="building_uid_appendix"
						:placeholder="propBuildingUidAppPlaceholder"
					></theme-input>

					<theme-input 
						:label="propStreet" 
						name="street" 
						v-validate="`required|alpha_num_spaces`"
						:isRequired="true"
						:placeholder="propStreetPlaceholder"
					></theme-input>

					<theme-calendar 
						:label="propAvailableFrom" 
						name="available_from" 
						v-validate="`required`"
						:isRequired="true"
						:placeholder="propAvailableFromPlaceholder"
					></theme-calendar>

					<theme-calendar 
						:label="propAvailableUntil" 
						name="available_until"
						:placeholder="propAvailableUntilPlaceholder"
					></theme-calendar>

					<theme-autocomplete
						name='location_id'
						:label="propLocation"
						endpoint="/admin/autocomplete/locations"
						:resolve="(item) => item.name"
						:isRequired="true"
						:placeholder="propLocationPlaceholder"
						v-validate="`required|location`"
					></theme-autocomplete>

					<theme-input 
						:label="propDesiredRentalPrice" 
						type="number" 
						:name="propDesiredRentalPriceName" 
						:placeholder="'€ ' + propMonth"
					></theme-input>

					<theme-input 
						:label="propMaxNumber" 
						type="number" 
						name="max_people" 
						:placeholder="propMaxNumberPlaceholder"
					></theme-input>
				</div>

				<a 
					class="theme-btn theme-btn--primary  self-start" 
					:href="calculatePriceLink" target="_blank">
					{{ locales && locales.properties && locales.properties.calculate_property_rent_price }}
				</a>

				<div>
					<h3 class="mb-5 md:mb-8 ">
						{{propPriceIncludes}}
					</h3> 
					<div class="grid grid-cols-2 gap-5 md:grid-cols-4 md:gap-8">
						<template v-for="item in checkBoxArray">
							<input 
								type='hidden' 
								:name="propServicesName + `[` + item + `]`" 
								value="0" />
							<theme-checkboxes 
								:value="propServicesValue" 
								:name="propServicesName + `[` + item + `]`" 
								:options="{1:locales && locales.properties && locales.properties[item]}"
							></theme-checkboxes>
						</template>
					</div>
				</div>

				<div class="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-8">
					<theme-select 
						:label="propType" 
						name="type_id" 
						value="0" 
						:zero-option="propUnknown"
						:options="propTypeOpt" 
						v-validate="`required`"
						:isRequired="true"
					></theme-select>

					<theme-select 
						:label="propInterior" 
						name="furnishing_id" 
						value="0" 
						:zero-option="propUnknown"
						:options="propInteriorOpt" 
						v-validate="`required`"
						:isRequired="true"
					></theme-select>

					<theme-input 
						:label="propBedrooms" 
						type="number" 
						name="no_bedrooms" 
						:placeholder="propRooms">
					</theme-input>

					<theme-input 
						:label="propSurface" 
						type="number" 
						name="area" 
						placeholder="m2">
					</theme-input>

					<theme-input 
						:label="propParkingPlaces" 
						type="number" 
						name="no_parking_places" 
						:placeholder="propPlaces">
					</theme-input>

					<theme-select 
						:label-html="subscriptionsParkingPlace" 
						name="parking_type_id" 
						value="0"
						:zero-option="propUnknown" 
						:options="subscriptionsParkingPlaceOpt">
					</theme-select>

				</div>

				<theme-textarea
					:label="propOtherInformation"
					name="description_trans[nl]"
					:placeholder="propOtherInformationPlaceholder"
				></theme-textarea>

			</div>

			<div class="flex flex-col gap-6 mb-6 md:mb-8">
				<h2 class="section-title-xs">{{ propPhotos }}</h2>

				<p><strong>{{propImageUploadText}}</strong></p>

				<theme-multiple-files
					accept="image/*"
					name="photos[]"
					id="1"
					:hint="propImageUploadTip"
				></theme-multiple-files>
			</div>

			<theme-checkboxes 
				class="form__radio mb-5 md:mb-8" 
				:rules="`required`"
				:options="{ '1': confirmTermsOfUse}"
			></theme-checkboxes>
				
			<v-recaptcha v-if="isRecaptcha === 'true'" 
				@validate="checkRecaptcha" 
				:site-key="recaptchaKey"
			></v-recaptcha>

			<button class="theme-btn theme-btn--primary theme-btn--block" @click.prevent="submitForm">{{buttonName}}</button>
		</div>
	</div>
</template>

<script>
import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
	inject: ['$validator'],
	components: {},
	data () {
		return {
			is_user_already_exists: 0,
			recaptchaTicked: false,
		}
	},
	computed: {
		...mapGetters(["locales"]),
	},
	props: {
		buttonName: {
			default: 'Submit',
			type: String
		},
		buttonAlign: {
			default: 'left',
			type: String
		},
		showSuccess: {
			default: 1,
			type: Number
		},
		successText: {
			default: '',
			type: String
		},
		errorText: {
			default: '',
			type: String
		},
		isRecaptcha: {
			default: 'false',
			type: String
		},
		recaptchaMessage: {
			default: 'Please tick recaptcha',
			type: String
		},
		recaptchaKey: {
			default: '',
			type: String
		},
		subscriptionsYourDetails: {
			default: '',
			type: String
		},
		usersCompanyName: {
			default: '',
			type: String
		},
		usersCompanyNamePlaceholder: {
			default: '',
			type: String
		},
		usersSex: {
			default: () => {},
			type: Object
		},
		usersFirstName: {
			default: '',
			type: String
		},
		usersFirstNamePlaceholder: {
			default: '',
			type: String
		},
		usersMiddleName: {
			default: '',
			type: String
		},
		usersMiddleNamePlaceholder: {
			default: '',
			type: String
		},
		usersLastName: {
			default: '',
			type: String
		},
		usersLastNamePlaceholder: {
			default: '',
			type: String
		},
		usersPhoneNumber: {
			default: '',
			type: String
		},
		usersPhoneNumberPlaceholder: {
			default: '',
			type: String
		},
		usersEmail: {
			default: '',
			type: String
    },
		usersEmailPlaceholder: {
			default: '',
			type: String
    },
    usersBankAccount: {
			default: '',
			type: String
    },
    usersBic: {
			default: '',
			type: String
		},
		userAlreadyExists: {
			default: '',
			type: String
		},
		propDetails: {
			default: '',
			type: String
		},
		propPostCode: {
			default: '',
			type: String
		},
		propPostCodePlaceholder: {
			default: '',
			type: String
		},
		propBuildingUid: {
			default: '',
			type: String
		},
		propBuildingUidPlaceholder: {
			default: '',
			type: String
		},
		propBuildingUidApp: {
			default: '',
			type: String
		},
		propBuildingUidAppPlaceholder: {
			default: '',
			type: String
		},
		propStreet: {
			default: '',
			type: String
		},
		propStreetPlaceholder: {
			default: '',
			type: String
		},
		propLocation: {
			default: '',
			type: String
		},
		propLocationPlaceholder: {
			default: '',
			type: String
		},
		propAvailableFrom: {
			default: '',
			type: String
		},
		propAvailableFromPlaceholder: {
			default: '',
			type: String
		},
		propAvailableUntil: {
			default: '',
			type: String
		},
		propAvailableUntilPlaceholder: {
			default: '',
			type: String
		},
		propDesiredRentalPrice: {
			default: '',
			type: String
		},
		propDesiredRentalPriceName: {
			default: '',
			type: String
		},
		propMonth: {
			default: '',
			type: String
		},
		propMaxNumber: {
			default: '',
			type: String
		},
		propMaxNumberPlaceholder: {
			default: '',
			type: String
		},
		propPriceIncludes: {
			default: '',
			type: String
		},
		propServicesName: {
			default: '',
			type: String
		},
		propServicesValue: {
			default: '',
			type: String
		},
		propType: {
			default: '',
			type: String
		},
		propUnknown: {
			default: '',
			type: String
		},
		propTypeOpt: {
			default: () => {},
			type: Object
		},
		propInterior: {
			default: '',
			type: String
		},
		propInteriorOpt: {
			default: () => {},
			type: Object
		},
		propBedrooms: {
			default: '',
			type: String
		},
		propRooms: {
			default: '',
			type: String
		},
		propSurface: {
			default: '',
			type: String
		},
		propParkingPlaces: {
			default: '',
			type: String
		},
		propPlaces: {
			default: '',
			type: String
		},
		subscriptionsParkingPlace: {
			default: '',
			type: String
		},
		subscriptionsParkingPlaceOpt: {
			default: () => {},
			type: Object
		},
		propOtherInformation: {
			default: '',
			type: String
		},
		propOtherInformationPlaceholder: {
			default: '',
			type: String
		},
		propPhotos: {
			default: '',
			type: String
		},
		propImageUploadText: {
			default: '',
			type: String
		},
		propImageUploadTip: {
			default: '',
			type: String
		},
		confirmTermsOfUse: {
			default: '',
			type: String
		},
		checkBoxArray: {
			default: () => [],
			type: Array
    },
    calculatePriceLink: {
			default: '',
			type: String
		},
		usersPassword: {
			default: '',
			type: String
    	},
		usersPasswordRepeat: {
			default: '',
			type: String
    	},
		usersPasswordPlaceholder: {
			default: '',
			type: String
    	},
		usersPasswordRepeatPlaceholder: {
			default: '',
			type: String
    	},
	},
	methods: {
		checkMail: function (event) {
			var email = event.target.value;
			if (email == '')
				return this.is_user_already_exists = 0;
			var vm = this;
			$.ajax({
				url: `/api/users/check-mail`,
				method: 'post',
				data: {
					email: email
				},
				success: function (result) {
					vm.is_user_already_exists = +result;
				},
				error: function () {
				}
			});
		},
		checkRecaptcha: function (result) {
			if (result === false) {
				this.recaptchaTicked = false;
			} else {
				this.recaptchaTicked = true;
			}
		},
		submitForm: function (e) {
			e.preventDefault();
			this.$validator.validateAll().then((res) => {
				if (this.isRecaptcha === 'true') {
					if (!this.recaptchaTicked) {
						sweetalert(window.app.locales.common.error, this.recaptchaMessage, 'error');
						return;
					}
				} 
				if (res) {
					let form = $('#form');
					// let fileInput = document.querySelector('input[type="file"]');
					let data = $('form').serialize();
					// let data = $('form').serializeArray();
					// let newData = new FormData();
					var message= this.successText;
					var errorMessage= this.errorText;
					if(this.showSuccess) {

						// in cases if we need to pass the photos. Need to handle this on the BE
						// for (let i = 0; i < data.length; i++) {
						// 	newData.append(data[i].name, data[i].value);
						// }

						// if (fileInput) {
						// 	if (fileInput.files.length) {
						// 		for (let i = 0; i < fileInput.files.length; i++) {
						// 			if (window.FileReader) {
						// 				let reader = new FileReader();
						// 				reader.readAsDataURL(fileInput.files[i]);
						// 			}
						// 			newData.append(`photos[${i}]` ,fileInput.files[i])
						// 		}
						// 	}
						// }

						$.ajax({
							url: form.attr('action'),
							method: 'post',
							data: data,
							// data: newData,
							// processData: false,
							success: function (result) {
								if(result.url!==undefined){
									if(message!==''){
										sweetalert(window.app.locales.common.success,message, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}else{
										sweetalert(window.app.locales.common.success,window.app.locales.subscriptions.successfully_added, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}
								}
							},
							error: function(result){
								if(result.responseJSON.url!==undefined){
									if(errorMessage!==''){
										sweetalert(window.app.locales.common.error,errorMessage, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}else{
										sweetalert(window.app.locales.common.error,window.app.locales.common.error, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}
								}
							}
						});
					}else{
						form.submit();
					}
				} else {
					sweetalert(window.app.locales.common.error, window.app.locales.subscriptions.form_with_errors, 'error');
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// resources/js/components/RentPropertyShForm.vue